import { render, staticRenderFns } from "./NewVolunteerProgram.vue?vue&type=template&id=b12dd854&scoped=true"
import script from "./NewVolunteerProgram.vue?vue&type=script&lang=js"
export * from "./NewVolunteerProgram.vue?vue&type=script&lang=js"
import style0 from "./NewVolunteerProgram.vue?vue&type=style&index=0&id=b12dd854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12dd854",
  null
  
)

export default component.exports